const API = process.env.REACT_APP_MTH_API_URL;
const STORAGE_KEY = "metal-class-token";

let memoryToken = sessionStorage.getItem(STORAGE_KEY);

export const getToken = () => memoryToken;

export const clearSession = () => {
  memoryToken = null;
  sessionStorage.removeItem(STORAGE_KEY);
};

const readError = async (res) => {
  try {
    const body = await res.json();
    return typeof body.detail === "string" ? body.detail : `Errore (${res.status})`;
  } catch {
    return `Errore (${res.status})`;
  }
};

export const login = async (username, password) => {
  const res = await fetch(`${API}/auth/login`, {
    method: "POST",
    mode: "cors",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ username, password }),
  });
  if (!res.ok) throw new Error(await readError(res));
  const result = await res.json();
  if (!result.access_token) throw new Error("Token non valido");
  memoryToken = result.access_token;
  sessionStorage.setItem(STORAGE_KEY, result.access_token);
  return result;
};

export const apiFetch = async (path, options = {}) => {
  const headers = { Accept: "application/json" };
  if (memoryToken) headers.Authorization = `Bearer ${memoryToken}`;
  if (options.body) headers["Content-Type"] = "application/json";
  const res = await fetch(`${API}${path}`, {
    mode: "cors",
    ...options,
    headers,
    signal: AbortSignal.timeout(30000),
  });
  if (res.status === 401) {
    clearSession();
    throw new Error("session_expired");
  }
  if (!res.ok) throw new Error(await readError(res));
  if (res.status === 204) return null;
  return res.json();
};

export const getMe = () => apiFetch("/auth/me");
export const getClassifications = (skip = 0, limit = 200) =>
  apiFetch(`/classifications?skip=${skip}&limit=${limit}`);
export const getClassification = (id) => apiFetch(`/classifications/${id}`);
export const deleteClassification = (id) =>
  apiFetch(`/classifications/${id}`, { method: "DELETE" });
export const getSuppliers = () => apiFetch("/suppliers");
export const createSupplier = (name) =>
  apiFetch("/suppliers", { method: "POST", body: JSON.stringify({ name }) });
export const deleteSupplier = (id) =>
  apiFetch(`/suppliers/${id}`, { method: "DELETE" });
export const getAdminUsers = () => apiFetch("/admin/users");
export const approveUser = (id) =>
  apiFetch(`/admin/users/${id}/approve`, { method: "PUT" });
export const blockUser = (id) =>
  apiFetch(`/admin/users/${id}/block`, { method: "PUT" });
export const deleteUser = (id) =>
  apiFetch(`/admin/users/${id}`, { method: "DELETE" });
export const getCompanySettings = () => apiFetch("/admin/company-settings");
export const updateCompanyEmail = (email_classifiche) =>
  apiFetch("/admin/company-settings", {
    method: "PUT",
    body: JSON.stringify({ email_classifiche }),
  });

export const getCompanies = () => apiFetch("/superadmin/companies");
// Endpoint lento (~6s): usato in background per arricchire la lista veloce
export const getCompaniesDetails = () => apiFetch("/superadmin/companies/details");
export const getSuperStats = () => apiFetch("/superadmin/stats");
export const toggleCompanyActive = (id) =>
  apiFetch(`/superadmin/companies/${id}/toggle-active`, { method: "PUT" });

export const photoUrl = (p) => {
  if (p.startsWith("http")) return p;
  const key = p.startsWith("/") ? p.slice(1) : p;
  return `${API}/photos/${key}`;
};

// Risolve un riferimento foto (data URI, URL http o chiave object storage)
// in un src usabile da <img>: data URI restano tali, le chiavi storage
// vengono scaricate con token Bearer e convertite in blob URL.
export const resolvePhoto = async (p) => {
  if (!p || typeof p !== "string") return "";
  if (p.startsWith("data:") || p.startsWith("blob:")) return p;
  return fetchAuthImage(photoUrl(p));
};

export const fetchAuthImage = async (url) => {
  const headers = {};
  if (memoryToken) headers.Authorization = `Bearer ${memoryToken}`;
  const res = await fetch(url, { mode: "cors", headers });
  if (!res.ok) throw new Error("image_error");
  return URL.createObjectURL(await res.blob());
};
